import { Grid, Card, CardContent, Typography, Box, Alert } from '@mui/material';
import Iconify from '../../../components/iconify';

const CARDS = [
  {
    key: 'earnedLeaves',
    label: 'Earned Leaves',
    icon: 'eva:award-fill',
    color: '#1877F2',
    bg: '#D0E8FF',
  },
  {
    key: 'privilegedLeaves',
    label: 'Privileged Leaves',
    icon: 'eva:star-fill',
    color: '#0A8043',
    bg: '#C8F5DC',
  },
  {
    key: 'leavesTaken',
    label: 'Leaves Used',
    icon: 'eva:calendar-fill',
    color: '#B76E00',
    bg: '#FFF3CD',
  },
  {
    key: 'upcomingLeaves',
    label: 'Upcoming Leaves',
    icon: 'eva:clock-fill',
    color: '#C4390A',
    bg: '#FFE4D9',
  },
  {
    key: 'extraLeaves',
    label: 'Extra Leaves',
    icon: 'eva:alert-triangle-fill',
    color: '#D32F2F',
    bg: '#FDECEA',
  },
  {
    key: 'leaveBalance',
    label: 'Leave Balance',
    icon: 'eva:checkmark-circle-2-fill',
    color: '#7635DC',
    bg: '#EBD6FD',
  },
];

export default function LeaveBalanceCards({ data }) {
  const isIntern = data?.isMonthlyAccrual;
  const monthsUnlocked = data?.monthsUnlocked ?? 0;

  return (
    <>
      {isIntern && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Your leave balance accrues monthly (1 leave/month). Unlocked so far this year:{' '}
          <strong>{monthsUnlocked} month{monthsUnlocked !== 1 ? 's' : ''}</strong>.
        </Alert>
      )}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {CARDS.filter(({ key }) => key !== 'extraLeaves' || (data?.extraLeaves > 0)).map(({ key, label, icon, color, bg }) => {
          const value = data?.[key];
          const display = value === null || value === undefined ? '--' : Number(value).toFixed(1);
          const mdSpan = data?.extraLeaves > 0 ? 2 : 2.4;
          return (
            <Grid item xs={12} sm={6} md={mdSpan} key={key}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        {label}
                      </Typography>
                      <Typography variant="h4" sx={{ color }}>
                        {display}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        bgcolor: bg,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Iconify icon={icon} width={24} sx={{ color }} />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
